import React, {useEffect, useState} from "react";
import Applausometro from "./Applausometro";
import Question from "./Questions/Question";
import {useParams} from "react-router-dom";
import {firestore} from "../firebase/clientApp";
import {Box, CircularProgress, Grow, Stack} from "@mui/material";
import {useCollection, useDocument} from "react-firebase-hooks/firestore";
import {DisplayName} from "./DisplayName";
import {PinnedQuestions} from "./PinnedQuestions";
import CountdownTimerWrapper from "./CountdownTimer";
import Agenda from "./Agenda/Agenda";
import ReactionsLive from "./ReactionsLive";

const LogoBox = ({logo}) => {
    return(
        <Box style={{width:'100%', height:'40%'}}>
            <img style={{ margin:'auto', width:'100%', height:'100%', objectFit:'contain'}} src={logo}/>
        </Box>
    )
}

export default function VoteContent({user, event, loading, userData, setUserData}) {
    const {eventOwnerId, id} = useParams()
    const [idPlaying, setIdPlaying] = useState('')
    const [eventPlaying, setEventPlaying] = useState('')
    const [pinned, pinnedLoading, pinnedError] = useCollection(firestore.collection(`users/${eventOwnerId}/events/${id}/queue`).where("pinned", "==",true), {})
    const url = `users/${eventOwnerId}/events/`
    const [theme, themeLoading, themeError] = useDocument(firestore.collection(`users/${eventOwnerId}/events/${id}/themes`).doc(event?.data().theme))

    useEffect(() => {
        getIdPlaying()
    }, [])

    useEffect(() => {

    }, [userData]);

    function getIdPlaying() {
        firestore.collection(url).doc(id).onSnapshot(s => {
            let e = s.data().elementPlaying
            let g = s.data().playing
            setIdPlaying(e)
            setEventPlaying(g)
        })
    }

    return (
        <Box>
            <Stack display={"flex"} flexDirection={'column'} justifyContent={"start"} alignContent={"center"}
                   sx={{height: '55vh', py: 2, position:'relative'}}
            >
                {event.data().autenticazione &&
                  <DisplayName userData={userData} setUserData={setUserData}/>}

                {event?.data()?.timer && !!event?.data()?.timer?.startedAt &&
                    <Grow in timeout={2000}>
                        <Box display={'flex'} justifyContent={'center'}>
                            <CountdownTimerWrapper label={event.data().timer.label} initialTime={event.data().timer.duration} isLive={event.data().timer.startedAt}
                                                   startedAt={event.data().timer.startedAt}/>

                        </Box>
                    </Grow>}

                {event.data().agenda && <Box>
                    <Agenda agendaContent={event.data()?.contenutoAgenda || []}/>
                </Box>}

                {!pinnedLoading && !pinnedError && pinned ?
                    event.data().autenticazione
                        ?
                        (userData.displayName !== '' && userData.displayName) &&
                        <PinnedQuestions questions={pinned}/>
                        :
                        <PinnedQuestions questions={pinned}/>
                    :
                    <></>
                }
            </Stack>
            {loading ?
                <Box sx={{textAlign: 'center'}}>
                    <CircularProgress/>
                </Box>
                :
                event.data().applausometro ?
                    event.data().autenticazione
                    ?
                    (userData.displayName !== '' && userData.displayName) &&
                        <ReactionsLive url={url + id} idPlaying={idPlaying} reactions={event.data().reactions} eventPlaying={eventPlaying} user={user}/>
                    :
                    <ReactionsLive url={url + id} idPlaying={idPlaying} reactions={event.data().reactions} eventPlaying={eventPlaying} user={user}/>
                :
                    <></>
            }
            {(theme && !themeLoading && !themeError && !loading) ?
                event.data().autenticazione
                    ?
                    (userData.displayName !== '' && userData.displayName) &&
                        <Question event={event} idPlaying={idPlaying} url={url + id} user={user} theme={theme.data()}/>
                    :
                    <Question event={event} idPlaying={idPlaying} url={url + id} user={user} theme={theme.data()}/>
                :
                <></>
            }
        </Box>

    )
}
